export default {
  'cancel-button': 'Cancel',
  'confirm-button': 'Confirm',
  'security-text': 'To ensure security, all data is encrypted',
}
